import React from 'react'
import Hero from './Hero'
import ContactForm from '../Home/Contact'
// import SocialInfo from './SocialInfo'
import { Helmet } from 'react-helmet-async'

const Contact = () => {
    return (
        <>
            <Helmet>
                <title> Contact - Website Design & Web Development Company In Nagpur</title>
                <link rel="canonical" href="/contact"></link>
                <meta name="description"
                    content="Discover how we can help your business grow. Ask for a quote: web design & development, SEO, mobile app development, Digital Marketing, landing page development."
                    data-rh="true" />

                <meta name="keywords"
                    content="contact web design company Nagpur, get quote for web development, website design company Nagpur, web design services, software company contact number Nagpur, it company near me, web development services Nagpur, BEST seo company Nagpur, seo company contact number Nagpur, it company near me, website designing services in Nagpur, digital marketing Nagpur" />
            </Helmet>
            <Hero />
            <ContactForm />
            {/* <SocialInfo /> */}
        </>
    )
}

export default Contact